var _path, _path2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgInstallMobile = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.181,
    height: 32,
    viewBox: "0 0 32.181 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.454 24.727h-14.545v-17.455h10.182v-7.2727h-10.182c-1.6 0-2.909 1.3091-2.909 2.9091v26.182c0 1.6 1.309 2.9091 2.909 2.9091h14.545c1.6 0 2.909-1.3091 2.909-2.9091v-7.2727h-2.909z",
    strokeWidth: 1.4545
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.908 18.909 7.2725-7.2727-2.0508-2.0509-3.7672 3.7527v-10.429h-2.909v10.429l-3.7672-3.7527-2.0508 2.0509z",
    strokeWidth: 1.4545
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstallMobile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/install_mobile.ee93b0bf.svg";
export { ForwardRef as ReactComponent };